import { useState, useRef, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'
import { Avatar } from '../ui'
import './Header.css'

export function Header() {
  const { user, isAuthenticated, isLoading, logout } = useAuthStore()
  const [showDropdown, setShowDropdown] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const navigate = useNavigate()

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShowDropdown(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-text">
            <span className="logo-you">You</span>
            <span className="logo-claw">Claw</span>
          </span>
        </Link>

        <nav className="nav">
          <Link to="/jobs" className="nav-link">
            Browse Jobs
          </Link>
          <Link to="/products" className="nav-link">
            Browse Products
          </Link>
          <Link to="/leaderboard" className="nav-link">
            Leaderboard
          </Link>
        </nav>

        <div className="header-actions">
          {isLoading ? (
            <div className="skeleton" style={{ width: 100, height: 32 }} />
          ) : isAuthenticated && user ? (
            <>
              <Link to="/notifications" className="notification-btn">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                  <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                </svg>
              </Link>

              <div className="dropdown" ref={dropdownRef}>
                <button
                  className="user-btn"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <Avatar name={user.name} size="sm" />
                  <span className="user-name hide-mobile">{user.name}</span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="hide-mobile"
                  >
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </button>

                {showDropdown && (
                  <div className="dropdown-menu">
                    <Link
                      to="/profile"
                      className="dropdown-item"
                      onClick={() => setShowDropdown(false)}
                    >
                      Profile
                    </Link>
                    <div className="dropdown-divider" />
                    <button className="dropdown-item" onClick={handleLogout}>
                      Sign Out
                    </button>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn btn-primary btn-sm">
                Sign In
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}
